export const getCookie = (cookieName: string) => {
  const name = cookieName + '=';
  const cookies = document?.cookie?.split('; ');
  const cookieVal = cookies ? cookies?.find((row) => row?.startsWith(name))?.split('=')[1] : undefined;
  return cookieVal;
};
